import { render, staticRenderFns } from "./card-ticket-new.vue?vue&type=template&id=58ca4c1b&scoped=true&"
import script from "./card-ticket-new.vue?vue&type=script&lang=js&"
export * from "./card-ticket-new.vue?vue&type=script&lang=js&"
import style0 from "./card-ticket-new.vue?vue&type=style&index=0&id=58ca4c1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca4c1b",
  null
  
)

export default component.exports